import React, {CSSProperties, MouseEventHandler} from 'react'
import PropTypes from 'prop-types';
import Theme from 'Theme'

interface Props {
  isOpen: boolean
  menuClicked: MouseEventHandler,
  width?: number,
  height?: number,
  strokeWidth?: number,
  rotate?: number,
  color?: string,
  borderRadius?: number,
  animationDuration?: number
}

const HamburgerMenu = (props: Props) => {
  const
    width       = `${props.width || 20}px`,
    height            = `${props.height || 16}px`,
    halfHeight        = `${parseInt(height.replace('px', ''), 10) / 2}px`,
    isOpen            = props.isOpen || false,
    strokeWidth       = props.strokeWidth || 2,
    halfStrokeWidth   = `-${strokeWidth / 2}px`,
    animationDuration = props.animationDuration || 0.4;

  const getTransformValue = (isOpened, defaultPos, rotateVal) => (
    `translate3d(0,${isOpened ? halfHeight : defaultPos},0) rotate(${isOpened ? `${rotateVal}deg` : '0'})`
  );

  const container = {
    width,
    height,
    position: 'relative',
    transform: `rotate(${props.rotate || 0}deg)`,
  } as CSSProperties

  const lineBase = {
    display: 'block',
    height: `${strokeWidth}px`,
    width: '100%',
    background: props.color || Theme.color.secondary,
    transitionTimingFunction: 'ease',
    transitionDuration : `${animationDuration}s`,
    borderRadius: `${props.borderRadius || 0}px`,
    transformOrigin: 'center',
    position: 'absolute'
  } as CSSProperties

  const firstLine = {
    transform: getTransformValue(isOpen, 0, 45),
    marginTop: halfStrokeWidth,
  } as CSSProperties

  const secondLine = {
    transitionTimingFunction: 'ease-out',
    transitionDuration : `${animationDuration! / 4}s`,
    opacity: isOpen ? 0 : 1,
    top: halfHeight,
    marginTop: halfStrokeWidth
  } as CSSProperties

  const thirdLine = {
    transform: getTransformValue(isOpen, height, -45),
    marginTop: halfStrokeWidth
  } as CSSProperties

  return (
    <div style={{
      ...container,
      margin: '10px'}}
      onClick={props.menuClicked}
    >
      <span style={{ ...lineBase, ...firstLine}}/>
      <span style={{...lineBase, ...secondLine}}/>
      <span style={{...lineBase, ...thirdLine}}/>
    </div>
  );
};

export default HamburgerMenu



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NavBarMobile/HamburgerMenu.tsx